import {css} from 'lit';
export const styles = css`.summary-container{margin:2rem 0;display:grid;grid-template-rows:auto;grid-template-columns:1fr;gap:2rem}@media screen and (min-width: 992px){.summary-container{grid-template-columns:1fr 1fr}}`;
export default styles;
